import { ButtonInfo } from "../items";

// 依頼詳細用権限情報model
export class ReceptionDetailPermissions {

  // 編集
  public edit: ButtonInfo;

  // 削除
  public delete: ButtonInfo;

  // 一時退避
  public suspend: ButtonInfo;

  // 退避解除
  public resume: ButtonInfo;

  // 取消
  public cancel: ButtonInfo;

  // 復活
  public return: ButtonInfo;

  // コピー
  public copy: ButtonInfo;

  // 引用
  public quote: ButtonInfo;

  // WF他医依頼
  public requestAnother: ButtonInfo;

  // 文書参照
  public documentShow: ButtonInfo;

  // 文書作成
  public documentCreate: ButtonInfo;

  // 文書引用
  public documentQuote: ButtonInfo;

  // 文書編集
  public documentEdit: ButtonInfo;

  // WF確認（承認）
  public approve: ButtonInfo;

  // WF差戻し
  public sendBack: ButtonInfo;

  // WF差戻し＆編集
  public sendBackAndEdit: ButtonInfo;

  // 発行
  public publish: ButtonInfo;

  // WF終了
  public finish: ButtonInfo;

  // WF終了取消
  public cancelFinish: ButtonInfo;

  // WFコストなし終了
  public finishWithoutCost: ButtonInfo;

  // 受領書発行
  public publishReceipt: ButtonInfo;

  // 伝達事項
  public nextMessage: ButtonInfo;

  // 差戻しコメント
  public backMessage: ButtonInfo;

  // 削除コメント
  public deleteMessage: ButtonInfo;


  // 依頼書参照
  public requestSheetShow: ButtonInfo;

  // 依頼書作成
  public requestSheetCreate: ButtonInfo;

  // 依頼書編集
  public requestSheetEdit: ButtonInfo;

  // 依頼書削除
  public requestSheetDelete: ButtonInfo;
}
